import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ComfortIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M18.98 4.48C20.78 10.92 20.78 14.12 18.98 19.44C13.18 17.64 10.98 17.64 5.02 19.44C3.22 13 3.22 9.8 5.02 4.48C10.82 6.28 13.02 6.28 18.98 4.48ZM6.44 17.12C11.04 15.78 13.1 15.8 17.6 17.14C18.7 13.54 18.68 11.1 17.56 6.8C12.96 8.14 10.9 8.12 6.4 6.78C5.3 10.38 5.32 12.82 6.44 17.12ZM7.34 15.04C7.6 12.98 7.6 10.96 7.34 8.9H9.14C9.36 11.96 9.36 11.98 9.14 15.04H7.34Z" />
    </SvgIcon>
  );
});
